import VariationSelection1 from "./VariationSelection1/VariationSelection1.vue";
import VariationProduct from "../../SingleProductPrice3/VariationProduct.vue";


export const variationSelection = {
    VariationSelection1,
    VariationProduct
}